var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
      _c("div", { staticClass: "swiper-container" }, [
        _c("div", { staticClass: "swiper-wrapper" }, [
          _c("div", { staticClass: "swiper-slide" }, [
            _c("img", {
              staticClass: "toBeCropped",
              attrs: { src: _vm.product.images[0] }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-pagination" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12 col-md-6" }, [
      _c(
        "div",
        {
          attrs: { id: "qb-close" },
          on: {
            click: function($event) {
              return _vm.$emit("close-quick")
            }
          }
        },
        [_c("i", { staticClass: "fal fa-times" })]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "p-name" }, [_vm._v(_vm._s(_vm.product.name))]),
      _vm._v(" "),
      _c("div", { staticClass: "p-price" }, [
        _c(
          "span",
          {
            staticClass: "current_price",
            class: { discount: _vm.product.discount },
            staticStyle: { "font-weight": "500" }
          },
          [
            _vm._v(
              _vm._s(
                _vm.product.discountPrice > 0
                  ? _vm.product.discountPrice
                  : _vm.product.price
              ) +
                " " +
                _vm._s(_vm.product.currency)
            )
          ]
        ),
        _vm._v(" "),
        _vm.product.discount &&
        _vm.product.priceList.includes(_vm.product.priceListId) == false
          ? _c("span", { staticClass: "base_price strike" }, [
              _vm._v(
                _vm._s(
                  _vm.product.discountPrice > 0 ? _vm.product.price : null
                ) +
                  "  " +
                  _vm._s(_vm.product.currency)
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.product.discount &&
        _vm.product.priceList.includes(_vm.product.priceListId)
          ? _c(
              "span",
              {
                staticClass: "p-name",
                staticStyle: {
                  color: "#333",
                  "font-size": "14px",
                  "line-height": "normal",
                  display: "block",
                  "margin-top": "0px",
                  "text-transform": "none"
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.strings["lower_price_last_days"]) +
                    " " +
                    _vm._s(_vm.product.lower_price) +
                    " " +
                    _vm._s(_vm.product.currency) +
                    " " +
                    _vm._s(
                      _vm.product.discountPercentageLowerPrice < 0
                        ? "(" +
                            _vm.product.discountPercentageLowerPrice.toString() +
                            "%)"
                        : ""
                    ) +
                    " "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.product.discount &&
        _vm.product.priceList.includes(_vm.product.priceListId)
          ? _c(
              "span",
              {
                staticClass: "p-name",
                staticStyle: {
                  color: "#333",
                  "font-size": "14px",
                  "line-height": "normal",
                  display: "block",
                  "margin-top": "0px",
                  "text-transform": "none",
                  "margin-bottom": "10px"
                }
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.strings["publishing_price"]) +
                    " " +
                    _vm._s(_vm.product.original_price) +
                    " " +
                    _vm._s(_vm.product.currency) +
                    " (" +
                    _vm._s(_vm.product.discountPercentageOriginalPrice) +
                    "%)"
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "p-description" }, [
        _vm._v(_vm._s(_vm.product.description))
      ]),
      _vm._v(" "),
      _vm.product.skus !== null && !_vm.product.singleSku
        ? _c("div", { staticClass: "p-sizes" }, [
            _c("div", { staticClass: "header" }, [
              _c("span", { staticClass: "h-text" }, [
                _vm._v(_vm._s(_vm.strings["product_detail_choos_size"]))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sizes" }, [
              _c(
                "ul",
                _vm._l(_vm.product.skus, function(sku, keySku) {
                  return _c(
                    "li",
                    {
                      key: keySku,
                      staticClass: "sku",
                      class: { selected: _vm.selected === sku.id },
                      on: {
                        click: function($event) {
                          return _vm.active(sku.id)
                        }
                      }
                    },
                    [_vm._v(_vm._s(sku.size))]
                  )
                }),
                0
              )
            ])
          ])
        : _vm.product.skus !== null
        ? _c(
            "div",
            {
              staticClass: "sku selected hidden",
              attrs: { set: (_vm.selected = _vm.product.skus.id) }
            },
            [_vm._v(_vm._s(_vm.product.skus.size))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "actions",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "bottom",
            title: _vm.strings["choose_size"]
          }
        },
        [
          _c(
            "button",
            {
              staticClass: "bttn quicky",
              attrs: {
                type: "cart",
                name: "button",
                disabled: _vm.selected === null
              },
              on: { click: _vm.add }
            },
            [
              _vm.wishlist == false
                ? _c("span", { staticClass: "btn-label" }, [
                    _vm._v(_vm._s(_vm.strings["add_to_cart"]))
                  ])
                : _c("span", { staticClass: "btn-label" }, [
                    _vm._v(_vm._s(_vm.strings["add_to_wishlist"]))
                  ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "wishlist-msg pt3" }, [
        _vm._v(_vm._s(_vm.message))
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-logo" }, [
      _c("img", {
        attrs: { src: "/img/logo-pollini.jpg", alt: "Pollini Retail Spa" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }